// ======================
// == DEPRECATED TYPES ==
// ======================
/**
 * @deprecated use Announcement
 */
export type AnnouncementDeprecated = {
    id: string
    ge_title: string
    ge_description: string
    ge_priority: number
    readed: string
}

/**
 * @deprecated use ReferenceEntity
 */
export type ReferenceEntityDeprecated<Entity> = {
    Id: string
    Name?: string
    LogicalName?: string
    Attributes?: Entity
    entity?: Entity
}

/**
 * @deprecated use Contact
 */
export type ContactDeprecated = {
    id: string
    firstname: string
    lastname: string
    emailaddress1: string
    ge_institution1?: ReferenceEntityDeprecated<Account>
    ge_primaryrgid?: ReferenceEntityDeprecated<ResearchGroup>
    ge_defaultprojectid?: ReferenceEntityDeprecated<Project>
    ge_systemuserid: ReferenceEntityDeprecated<SystemUser>
    statecode?: number
    new_api_key?: string
    telephone1?: string
    ge_is_employee: boolean
    new_rfid?: string
    new_osobniemailuzivatele?: string
    new_osobnitelefonuzivatele?: string
    modifiedon: string
}

/**
 * @deprecated use SystemUser
 */
export type SystemUserDeprecated = {
    id: string
    firstname: string
    lastname: string
    internalemailaddress: string
    accessmode: number
    skills?: string
    businessunitid: {
        Id: string,
        Name: string
    }
    ge_contactid: {
        Id: string,
        Name: string,
        Attributes: ContactDeprecated
    }
}

/**
 * @deprecated use ServiceAppointment
 */
export type ServiceAppointmentDeprecated = {
    id: string
    createdon: string
    createdby: ReferenceEntityDeprecated<SystemUser>
    modifiedon: string
    modifiedby: ReferenceEntityDeprecated<SystemUser>
    statuscode: number
    statecode: number
    subject: string
    scheduledstart: string
    scheduledend: string
    description: string
    ge_privatedescription: string
    psa_timerequirement: number
    ownerid: ReferenceEntityDeprecated<SystemUser>
    ge_realised_for_contactid: ReferenceEntityDeprecated<Contact>
    ge_res_groupid: ReferenceEntityDeprecated<ResearchGroup>
    psa_projectid: ReferenceEntityDeprecated<Project>
    regardingobjectid: ReferenceEntityDeprecated<FormService>
    new_service_ticket: ReferenceEntityDeprecated<null>
    new_nazev_pristroje_text: string
    psa_additionalrequestcapacity: number
    new_privaterecording: boolean
    new_bluebox_verified: boolean
    new_project_order: number
    resources: Array<{
        Attributes: {
            partyid: ReferenceEntityDeprecated<EquipmentDeprecated>
        }
        Id: string
        LogicalName: string
    }>
    materialids: Array<{
        Attributes: {
            partyid: ReferenceEntityDeprecated<EquipmentDeprecated>
        }
        Id: string
        LogicalName: string
    }>
}

/**
 * @deprecated use Equipment
 */
export type EquipmentDeprecated = {
    id: string
    name: string
    ge_nameen: string
    ge_alias: string
    ge_status: EquipmentStatus
    ge_status_note: string
    ge_repairdate: string
    description: string
    ge_descriptionen: string
    new_umisteni: string
    businessunitid: ReferenceEntityDeprecated<BusinessUnit>
    ge_corefacilityid?: ReferenceEntityDeprecated<EquipmentDeprecated>
    ge_ownerid?: ReferenceEntityDeprecated<SystemUser>
    ge_logbook: string
    ge_defaultrequeststatecode: number
    materials: EquipmentDeprecated[]
    cenacas: number
    cenarezervace: number
    ge_cenaceitecinternirezervace: number
    ge_cenaceitecrezervace: number
    ge_cenaexternirezervace: number
    ge_cenapartnerskarezervace: number
    ge_rezervacecreatelimit: number
    ge_rezervacedeletelimit: number
}
/**
 * @deprecated use Campaign
 */
export type CampaignDeprecated = {
    id: string
    name: string
    ge_enname: string
    proposedstart: string
    proposedend: string
    ge_campaign_location: string
    ge_organizer_accountid: ReferenceEntityDeprecated<Account>
    ce_odpos_contacid: ReferenceEntityDeprecated<Contact>
}

// ===========
// == ENUMS ==
// ===========
export enum EquipmentStatus {
    Operational = 1,
    Issues = 2,
    NonOperational = 3,
}
export enum EquipmentRawDataUploadStatus {
    Progress = 'progress',
    Done = 'done',
    Error = 'error',
}
export enum EquipmentWarningStatus {
    Info = 200000000,
    Danger = 200000001,
    Warning = 200000002,
}
export enum ScreenType {
    Screen = 'screen',
    Document = 'document',
}

// ===================
// == SERVICE TYPES ==
// ===================
export type Locales = {
    [key: string]: {
        [key: string]: string
    }
}

export type ReferenceEntity<Entity> = Entity

// ACCOUNT
export type Account = {
    id: string
    name: string
    ge_name_eng: string
}

// ANNOUNCEMENT AUDIENCE
export type AnnouncementAudience = {
    ge_annoucementid: {
        id: string
    },
    ge_systemuserid: {
        id?: string
    },
    ge_res_groupid: {
        id?: string
    },
    ge_equipmentid: {
        id?: string
    },
    createdby: {
        id: string
    },
    createdon: string,
    modifiedby: {
        id: string
    },
    modifiedon: string,
    statecode: number,
    statuscode: number,
    id: string
}

// ANNOUNCEMENT
export type AnnouncementDefinition = {
    id: string
    ge_title: string,
    ge_description: string
    ge_allusers: boolean
    ge_priority: number
    ge_validfrom: string
    ge_validto: string
    ge_systemuserid: string[]
    ge_res_groupid: string[]
    ge_equipmentid: string[]
}

export type AnnouncementEditDefinition = {
    id: string
    ge_title: string,
    ge_description: string
    ge_allusers: boolean
    ge_priority: number
    ge_validfrom: string
    ge_validto: string
    ge_systemuserid: [{
        id: string,
        label: string,
        description: string
    }]
    ge_res_groupid: [{
        id: string,
        label: string,
        description: string
    }]
    ge_equipmentid: [{
        id: string,
        label: string,
        description: string
    }]
}

// BUSINESS UNIT
export type BusinessUnit = {
    id: string
    name: string
    new_serviceappointment_form: number
    new_serviceappointment_form_researchgroup: ReferenceEntityDeprecated<ResearchGroup>
}

// CAMPAIGN
export type Campaign = {
    id: string
    name: string
    ge_enname: string
    proposedstart: string
    proposedend: string
    ge_campaign_location: string
    ge_organizer_accountid: Account
    ce_odpos_contacid: Contact
}

// CERTIFICATION
export type Certification = {
    id: string
    ge_name: string
}

// CONTACT
export type Contact = {
    id: string
    firstname: string
    lastname: string
    emailaddress1: string
    ge_institution1?: ReferenceEntity<Account>
    ge_primaryrgid?: ReferenceEntity<ResearchGroup>
    ge_defaultprojectid?: ReferenceEntityDeprecated<Project>
    ge_systemuserid: ReferenceEntity<SystemUser>
    statecode?: number
    new_api_key?: string
    telephone1?: string
    ge_is_employee: boolean
    new_rfid?: string
    new_osobniemailuzivatele?: string
    new_osobnitelefonuzivatele?: string
    modifiedon: string
}

// EQUIPMENT
export type EquipmentRawDataStructure = {
    id: string
    new_name: string
    new_path: string
    new_onedata_directory_fileid: string
    new_is_directory: boolean
    new_recording: ReferenceEntity<Recording>
    new_equipment_rawdata: ReferenceEntity<EquipmentRawData>
    new_parent_directory: ReferenceEntity<EquipmentRawDataStructure>
}

export type EquipmentWarning = {
    id: string
    createdon: string
    new_name: string
    new_equipment: ReferenceEntity<Equipment>
    new_status: EquipmentWarningStatus
    new_start: string
    new_end: string
}

export type Equipment = {
    id: string
    name: string
    ge_nameen?: string
    ge_alias?: string
    ge_status?: EquipmentStatus
    ge_status_note?: string
    ge_repairdate?: string
    description?: string
    ge_descriptionen?: string
    new_umisteni?: string
    businessunitid?: ReferenceEntity<BusinessUnit>
    ge_corefacilityid?: ReferenceEntity<Equipment>
    ge_ownerid?: ReferenceEntity<SystemUser>
    ge_logbook?: string
    ge_defaultrequeststatecode?: number
    materials?: Equipment[]
    cenacas?: number
    cenarezervace?: number
    ge_cenaceitecinternirezervace?: number
    ge_cenaceitecrezervace?: number
    ge_cenaexternirezervace?: number
    ge_cenapartnerskarezervace?: number
    ge_rezervacecreatelimit?: number
    ge_rezervacedeletelimit?: number
    new_onedata_storage?: string
}

export type EquipmentRawData = {
    id: string
    createdon: string
    ce_equipment: ReferenceEntity<Equipment>
    ce_onedata_file: ReferenceEntity<OneDataFile>
    ce_recording: ReferenceEntity<Recording>
    ce_upload_error: string
    ce_upload_status: EquipmentRawDataUploadStatus
    ce_time_create_local: string
    ce_localpath: string
}

// FAVORITE
export type Favourite = {
    Id: string
    id: string
    entityname: string
    ge_equipmentid: {
        Id: string,
        LogicalName: string,
        Name: string,
        Attributes: EquipmentDeprecated
    }
    equipment: {
        ge_alias: string
        ge_status: number
    }
    ge_calendarcolor: string
    new_calendartextcolor: string
    ge_order: number
    ge_favoritesid: string
    ge_selected: boolean
    new_group: string
}

// FORM SERVICE
export type FormService = {
    id: string
    ge_name: string
}

// GET TEXT
export type Gettext = {
    id: number,
    msgid: string,
    text_cs?: string,
    text_en?: string,
}

// PROJECT
export type Project = {
    id: string
    psa_name: string
    ge_name_eng: string
    ge_acronym?: string
    ge_project_start: string
    ge_project_end: string
    psa_projectcode: string
    statecode: number
    statuscode: number
}

// OND DATA
export type OneDataFile = {
    id: string,
    ce_name: string
    ce_filesize: number
}

// RECORDING
export type Recording = {
    id: string
    modifiedby: ReferenceEntity<SystemUser>
    modifiedon: string
    ownerid: ReferenceEntity<SystemUser>
    ge_name: string
    new_plan_experimentu_new: string
    new_vysledek_experimentu_new: string
    new_start: string
    new_end: string
    new_alert_end?: string
    new_sharepointfolder: string
    new_rawdata_reindex_done: boolean
    new_count_files: number
    new_count_files_adr_str: number
    new_stav_adr_str: string
    ge_status: number
    ge_sessionid?: ReferenceEntity<Session>
    new_equipmentid?: ReferenceEntity<Equipment>
    new_preview_file?: ReferenceEntity<SharepointFile>
    files: { [key: string]: SharepointFile }
    createdon: string
    new_stav_zip: string
    new_zip_file_name: string
    new_zip_file_size: number
    new_zip_file_url: string
    new_createdby_onbehalf?: ReferenceEntity<SystemUser>
    new_modifiedby_onbehalf?: ReferenceEntity<SystemUser>
}

export type RecordingAdrStr = {
    id: string
    new_name: string
    new_field_id: number
    new_field: string
    new_parent_id: number
    new_parent: string
    new_shp_url_full: string
    new_is_directory: boolean
    new_status_upload: string
    new_file_size: number
    new_file_size_text: string
    new_time_create_local: string
    new_onedata_file_id: string
}

export type RecordingUpdateData = {
    ge_name: string,
    ge_status: number,
    new_alert_end?: string,
    new_plan_experimentu_new: string,
    new_vysledek_experimentu_new: string
    new_preview_file?: string | null
    userFieldsValues: { [id: string]: string | boolean | number | null }
}

// REQUEST TRAINING
export type RequestTraining = {
    id: string
    createdon: string
    createdby: ReferenceEntity<SystemUser>
    ce_pristroj: ReferenceEntity<Equipment>
    ce_obsah_pozadavku: string
}

// RESEARCH GROUP
export type ResearchGroup = {
    id: string
    ge_name: string
    ge_name_eng: string
    ge_code: string
    ge_code_alternative: string
    ge_partner_ceitec: {
        id: string
    }
}

// SAMPLE
export type Sample = {
    id: string
    new_code: string
    ge_name: string
    ge_description: string
    ge_location: string
}

// SERVICE APPOINTMENT
export type ServiceAppointment = {
    id: string
    createdon: string
    createdby: ReferenceEntity<SystemUser>
    modifiedon: string
    modifiedby: ReferenceEntity<SystemUser>
    statuscode: number
    statecode: number
    subject: string
    scheduledstart: string
    scheduledend: string
    description: string
    ge_privatedescription: string
    psa_timerequirement: number
    ownerid: ReferenceEntity<SystemUser>
    ge_realised_for_contactid: ReferenceEntity<Contact>
    ge_res_groupid: ReferenceEntity<ResearchGroup>
    psa_projectid: ReferenceEntity<Project>
    regardingobjectid: ReferenceEntity<FormService>
    new_service_ticket: ReferenceEntity<null>
    psa_additionalrequestcapacity: number
    new_privaterecording: boolean
    new_project_order: number
}

export type ServiceAppointmentMaterial = {
    id?: string
    new_serviceappointment?: ReferenceEntity<ServiceAppointment>,
    new_material?: ReferenceEntity<Equipment>,
    new_count: number
}

export type ServiceAppointmentService = {
    id?: string
    new_serviceappointment?: ReferenceEntity<ServiceAppointmentDeprecated>,
    new_formservice?: ReferenceEntity<FormService>,
    new_count: number
}

// SESSION
export type Session = {
    id: string,
    ge_name: string,
    ge_equipmentid: ReferenceEntity<Equipment>,
    ge_serviceappointmentid: ReferenceEntity<ServiceAppointment>
}

// SHAREPOINT FILE
export type SharepointFile = {
    id: string
    new_name: string
    new_title: string
    new_shp_url: string
    new_file_size?: number
    thumbs: {
        xxl: {
            url: string
        },
        sm: {
            url: string
        }
    }
}

export type SharepointDocumentLocation = {
    id: string
    name: string
    relativeurl: string
    parentsiteorlocation: ReferenceEntityDeprecated<SharepointDocumentLocation>
}

// SYSTEM USER
export type SystemUser = {
    id: string
    firstname: string
    lastname: string
    internalemailaddress: string
    accessmode: number
    businessunitid: ReferenceEntity<BusinessUnit>
    ge_contactid: ReferenceEntity<Contact>
}

// TASK
export type Task = {
    id: string
    description: string
    subject: string
}

// USER FIELD
export type UserFieldDefinition = {
    id: string,
    ge_name: string,
    new_name_en: string,
    ge_order: number,
    ge_type: number,
    new_description: string,
    new_description_en: string,
    new_note: string,
    new_note_en: string,
    type_value_field: string,
    new_mandatory: boolean,
    new_hidden: boolean
    ge_default_value: string
    modifiedon: string,
    modifiedby: {
        id: string
    }
}

export type UserFieldValue = {
    value: string | boolean,
    modifiedOn: string | null,
    modifiedBy: string | null
}

// USER SETTINGS
export type UserSettings = {
    id: string,
    ge_systemuserid: ReferenceEntityDeprecated<SystemUser>,
    ge_languagecode: number,
    ge_planningboard: number,
    ge_timefrom: number,
    ge_timeto: number,
    new_theme: number
    new_labbook_mode: ELabBookMode
    ge_timezonedays: number,
    new_filtr_booking: string,
    new_booking_reservation_label: string,
}

export enum ELabBookMode {
    Minimized = 100000000,
    Default = 100000001,
    Expanded = 100000002
}

export type UserSettingsUpdate = {
    ge_languagecode: number
    ge_planningboard: number
    ge_timefrom: number
    ge_timeto: number
    new_theme: number
    new_labbook_mode: number
    ge_timezonedays: number
    new_booking_reservation_label: string
}

export type UserSettingsFilter = {
    statuses: { [key: string]: string },
    sidebarClosed: boolean,
    groups: { [key: string]: string },
    equipment: { [key: string]: string },
}
